<template>
  <div class="autocomplete">
    <!--{{ keywordSearch }}-->
    <input type="text" class="inp-search bg-blue s"
           id="s"
           :placeholder="placeHolderText"
           autocomplete="off"
           v-bind:value="keywordSearch"
           v-on:input="keywordSearch=$event.target.value"
           @keyup.down="onArrowDown" @keyup.up="onArrowUp" @keyup.enter="onEnter"
           :class="{ 'loading-circle' : (keywordSearch.length > 2), 'hide-loading-circle': resultSongItems.length > 0 || resultSongItems.length == 0 && !autoCompleteProgress || resultSingerItems.length > 0 || resultSingerItems.length == 0 && !autoCompleteProgress }"
           @input="onInput"/>
    <div>
      <ul class="autocomplete-results" v-if="resultSongItems.length > 0 || resultSingerItems.length > 0">
        <li class="autocomplete-result"
            v-for="
            (item,i) in resultSongItems" :key="i" @click="keywordSearch='';
            onSelected(item.songId, item.songName)"
            :class="{ 'active': i === valueArrowCounter }">
          {{ item.songName }}
        </li>

        <li class="autocomplete-result"
            v-for="
            (itemSinger,j) in resultSingerItems" :key="'singer' + j" @click="keywordSearch='';
            onSelectedSinger(itemSinger.id, itemSinger.singerName)"
            :class="{ 'active': j === valueArrowCounterSinger }">
          {{ itemSinger.singerName }} <span style="color: #ccc;">Ca sĩ</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Autocomplate",
    props: {
      placeHolderText: String,
      onChange: Function,
      onSelected: Function,
      onSelectedSinger: Function,
      onArrowDown: Function,
      onArrowUp: Function,
      onEnter: Function,
      resultItems: Array,
      resultSongItems: Array,
      resultSingerItems: Array,
      autoCompleteProgress: Boolean,
      itemText: String,
      itemId: String,
      valueInput: String,
      valueArrowCounter: Number,
      valueArrowCounterSinger: Number
    },
    data() {
      return {
        keywordSearch: ''
      }
    },
    methods: {
      onInput(){
        this.$emit("nameSearch", this.keywordSearch);
      }
    },
    watch: {
      "valueInput": function (val) {
        this.keywordSearch = val;
      }
    }
  }
</script>

<style scoped>
  .loading-circle {
    background-color: #ffffff;
    background-image: url("../../static/img/loading.gif");
    background-size: 16px 16px;
    background-position: right center;
    background-repeat: no-repeat;
  }

  .hide-loading-circle {
    background: none;
  }

  .form-textinput{
    padding:8px 10px;
    border-radius:5px;
    border:solid 1px #ccc;
    background-color: #dddddd;
  }

  .autocomplete {
    position: relative;
    width: 250px;
  }

  @media screen and (max-width: 782px){
    .autocomplete {
      width: 100%;
    }
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    min-height: 120px;
    max-height: 250px;
    overflow: auto;
    background-color:#fdf8f3;
    border-radius:5px;
    position: absolute;
    z-index: 100;
    width: 100%;
    text-align: left;
  }

  .autocomplete-results li{
    font-size: 13px !important;
  }

  /* width */
  .autocomplete-results::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  .autocomplete-results::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  .autocomplete-results::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  .autocomplete-results::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 10px;
    cursor: pointer;
  }
  ul li{
    margin-bottom: 0 !important;
    text-transform: none !important;
  }

  .autocomplete-result:hover {
    background-color: #00a4e9 ;
    color: white;
  }
  .autocomplete-result.active {
    background-color: #00a4e9 ;
    color: white;
  }
  input[type=text]:active, input[type=text]:focus{
    outline: none;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Autocomplete.vue